import { FRONT_APP, FRONT_APP_COMPLETED_ITEMS, FRONT_APP_COMPLETED_ITEMS_SUCCESS, FRONT_APP_FAILURE, FRONT_APP_SUCCESS, STORE_LOGIN_FAILURE, UPDATE_BULK_DT_PM_SUCCESS, UPDATE_COMMENT, UPDATE_COMMENT_SUCCESS, UPDATE_DT_PM, UPDATE_DT_PM_SUCCESS, UPDATE_FOLDER_NUMBER, UPDATE_FOLDER_NUMBER_SUCCESS, UPDATE_FRONTAPP_ROW, UPDATE_PROJECT_NAME, UPDATE_PROJECT_NAME_SUCCESS, START_FRONTAPP_TIMER, PAUSE_FRONTAPP_TIMER, RESUME_FRONTAPP_TIMER, START_FRONTAPP_TIMER_SUCCESS, PAUSE_FRONTAPP_TIMER_SUCCESS, RESUME_FRONTAPP_TIMER_SUCCESS, GET_FRONTAPP_TIMER_STATUS_SUCCESS, GET_CA_PHASE_TASKS, GET_CA_PHASE_TASKS_SUCCESS, GET_CA_PHASE_TASKS_FAILURE, UPDATE_CA_PHASE_TASKS, UPDATE_CA_PHASE_TASKS_SUCCESS, UPDATE_CA_PHASE_TASKS_FAILURE, GET_RUNNING_FRONTAPP_TASK, GET_RUNNING_FRONTAPP_TASK_SUCCESS, GET_RUNNING_FRONTAPP_TASK_FAILURE } from "../storeTypes";

const initialState: any = {
    loader: false,
    frontAppData: [],
    frontappCompletedData: [],
    updatingId: null,
    caPhaseTasksData: [],
    runningFrontAppTask: null,
}
const FrontAppReducer = (state = initialState, action: any) => {

    switch (action.type) {
        case FRONT_APP:
            return {
                ...state,
                loader: action.isSilent ? state.loader : true,
                apiEndPoint: action?.payload || state.apiEndPoint,
            };
        case FRONT_APP_SUCCESS:
            return {
                ...state,
                loader: false,
                frontAppData: action?.payload,
            };
        case FRONT_APP_COMPLETED_ITEMS:
            return {
                ...state,
                loader: action.isSilent ? state.loader : true,
                apiEndPointCompleted: action?.payload || state.apiEndPointCompleted,
            };
        case FRONT_APP_COMPLETED_ITEMS_SUCCESS:
            return {
                ...state,
                loader: false,
                frontappCompletedData: action?.payload,
            };
        case UPDATE_DT_PM:
            return {
                ...state,
                loader: true,
                updatingId: action.id
            }
        case UPDATE_BULK_DT_PM_SUCCESS: {
            const bulkUpdatedFrontApp = state.frontAppData?.data?.map((value: any) => {
                if (Array.isArray(action.payload)) {
                    const matchedRow = action.payload.find((r: any) => r.comment_id === value.comment_id);
                    if (matchedRow) return { ...value, ...matchedRow };
                }
                return value;
            }) || state.frontAppData?.data;

            const bulkUpdatedFrontAppCompleted = state.frontappCompletedData?.data?.map((value: any) => {
                if (Array.isArray(action.payload)) {
                    const matchedRow = action.payload.find((r: any) => r.comment_id === value.comment_id);
                    if (matchedRow) return { ...value, ...matchedRow };
                }
                return value;
            }) || state.frontappCompletedData?.data;

            return {
                ...state,
                loader: false,
                frontAppData: { ...state?.frontAppData, data: bulkUpdatedFrontApp },
                frontappCompletedData: { ...state?.frontappCompletedData, data: bulkUpdatedFrontAppCompleted }
            }
        }
        case UPDATE_DT_PM_SUCCESS:
            const updatedFrontApp = state.frontAppData?.data?.map((value: any) => {
                if (value.comment_id == action?.id) {
                    return { ...value, ...action?.payload?.data }
                }
                return value;
            }) || state.frontAppData?.data;

            const updatedFrontAppCompleted = state.frontappCompletedData?.data?.map((value: any) => {
                if (value.comment_id == action?.id) {
                    return { ...value, ...action?.payload?.data }
                }
                return value;
            }) || state.frontappCompletedData?.data;

            return {
                ...state,
                loader: false,
                updatingId: null,
                frontAppData: { ...(state?.frontAppData || {}), data: updatedFrontApp },
                frontappCompletedData: { ...(state?.frontappCompletedData || {}), data: updatedFrontAppCompleted }
            }
        case UPDATE_COMMENT:
            return {
                ...state,
                loader: true,
            }
        case UPDATE_COMMENT_SUCCESS:
            const updatedCommentPending = state.frontAppData?.data?.map((value: any) => {
                if (value.comment_id == action?.id) {
                    return { ...value, ...action?.payload?.data };
                }
                return value;
            }) || state.frontAppData?.data;

            const updatedCommentCompleted = state.frontappCompletedData?.data?.map((value: any) => {
                if (value.comment_id == action?.id) {
                    return { ...value, ...action?.payload?.data };
                }
                return value;
            }) || state.frontappCompletedData?.data;

            return {
                ...state,
                loader: false,
                frontAppData: { ...(state?.frontAppData || {}), data: updatedCommentPending },
                frontappCompletedData: { ...(state?.frontappCompletedData || {}), data: updatedCommentCompleted },
                updateComment: action?.payload
            }
        case UPDATE_FOLDER_NUMBER:
            return {
                ...state,
                loader: false
            }
        case UPDATE_FOLDER_NUMBER_SUCCESS:
            return {
                ...state,
                loader: false,
                updateFolder: action?.payload
            }
        case UPDATE_PROJECT_NAME:
            return {
                ...state,
                loader: true,
            }
        case UPDATE_PROJECT_NAME_SUCCESS:
            const updatedProjectPending = state.frontAppData?.data?.map((value: any) => {
                if (value.comment_id == action?.id) {
                    return { ...value, ...action?.payload?.data };
                }
                return value;
            }) || state.frontAppData?.data;

            const updatedProjectCompleted = state.frontappCompletedData?.data?.map((value: any) => {
                if (value.comment_id == action?.id) {
                    return { ...value, ...action?.payload?.data };
                }
                return value;
            }) || state.frontappCompletedData?.data;

            return {
                ...state,
                loader: false,
                frontAppData: { ...(state?.frontAppData || {}), data: updatedProjectPending },
                frontappCompletedData: { ...(state?.frontappCompletedData || {}), data: updatedProjectCompleted }
            }
        case UPDATE_FRONTAPP_ROW:
            let updatedFrontAppData = state?.frontAppData?.data?.map((value: any) => {
                return value?._id === action?.payload?.id ? action?.payload.data : value
            })
            return {
                ...state,
                frontAppData: { ...state?.frontAppData, data: updatedFrontAppData },
            };
        case FRONT_APP_FAILURE:
            return {
                ...state,
                loader: false,
                updatingId: null,
                error: action.payload
            };
        case STORE_LOGIN_FAILURE:
            return {
                ...state,
                loader: false
            }
        case START_FRONTAPP_TIMER:
        case PAUSE_FRONTAPP_TIMER:
        case RESUME_FRONTAPP_TIMER:
            return {
                ...state,
                loader: true,
            };
        case START_FRONTAPP_TIMER_SUCCESS:
        case PAUSE_FRONTAPP_TIMER_SUCCESS:
        case RESUME_FRONTAPP_TIMER_SUCCESS:
        case GET_FRONTAPP_TIMER_STATUS_SUCCESS:
            // Assuming action.payload contains the updated row/timer data
            // Depending on response structure, you can merge this into frontAppData
            return {
                ...state,
                loader: false,
                timerActionData: action.payload
            };
        case GET_CA_PHASE_TASKS:
            return {
                ...state,
                loader: action.isSilent ? state.loader : true,
            };
        case GET_CA_PHASE_TASKS_SUCCESS: {
            const { data, page } = action.payload;
            let newData = state.caPhaseTasksData;

            if (page > 1) {
                // Find existing array
                let existingArray = [];
                if (Array.isArray(newData?.data?.data)) {
                    existingArray = newData.data.data;
                } else if (Array.isArray(newData?.data)) {
                    existingArray = newData.data;
                } else if (Array.isArray(newData)) {
                    existingArray = newData;
                }

                // Find incoming array
                let incomingArray = [];
                let incomingPagination = null;
                if (Array.isArray(data?.data?.data)) {
                    incomingArray = data.data.data;
                    incomingPagination = data.data.pagination;
                } else if (Array.isArray(data?.data)) {
                    incomingArray = data.data;
                    incomingPagination = data.pagination;
                } else if (Array.isArray(data)) {
                    incomingArray = data;
                }

                if (existingArray.length > 0 && incomingArray.length > 0) {
                    const mergedArray = [...existingArray, ...incomingArray];

                    // Reconstruct based on existing state shape
                    if (Array.isArray(newData?.data?.data)) {
                        newData = {
                            ...newData,
                            data: {
                                ...newData.data,
                                data: mergedArray,
                                pagination: incomingPagination || newData.data.pagination
                            }
                        };
                    } else if (Array.isArray(newData?.data)) {
                        newData = {
                            ...newData,
                            data: mergedArray,
                            pagination: incomingPagination || newData.pagination
                        };
                    } else {
                        newData = mergedArray;
                    }
                } else {
                    newData = data;
                }
            } else {
                newData = data;
            }

            return {
                ...state,
                loader: false,
                caPhaseTasksData: newData,
            };
        }
        case GET_CA_PHASE_TASKS_FAILURE:
        case UPDATE_CA_PHASE_TASKS_FAILURE:
            return {
                ...state,
                loader: false,
                error: action.payload
            };
        case UPDATE_CA_PHASE_TASKS:
            return {
                ...state,
                loader: action.isSilent ? state.loader : true,
            };
        case UPDATE_CA_PHASE_TASKS_SUCCESS: {
            const payloadData = action.payload;
            const requestPayload = payloadData?.requestPayload || {};
            const updatedTask = payloadData?.data?._id ? payloadData.data : (payloadData?._id ? payloadData : null);
            let updatedCaPhaseTasksData = state.caPhaseTasksData;

            if (updatedTask && updatedTask._id) {
                const mapTasks = (arr: any[]) => arr.map((task: any) =>
                    task._id === updatedTask._id ? { ...task, ...updatedTask, ...requestPayload } : task
                );

                if (Array.isArray(updatedCaPhaseTasksData)) {
                    updatedCaPhaseTasksData = mapTasks(updatedCaPhaseTasksData);
                } else if (updatedCaPhaseTasksData?.data && Array.isArray(updatedCaPhaseTasksData.data)) {
                    updatedCaPhaseTasksData = {
                        ...updatedCaPhaseTasksData,
                        data: mapTasks(updatedCaPhaseTasksData.data)
                    };
                } else if (updatedCaPhaseTasksData?.data?.data && Array.isArray(updatedCaPhaseTasksData.data.data)) {
                    updatedCaPhaseTasksData = {
                        ...updatedCaPhaseTasksData,
                        data: {
                            ...updatedCaPhaseTasksData.data,
                            data: mapTasks(updatedCaPhaseTasksData.data.data)
                        }
                    };
                } else if (updatedCaPhaseTasksData?.data?.data?.data && Array.isArray(updatedCaPhaseTasksData.data.data.data)) {
                    updatedCaPhaseTasksData = {
                        ...updatedCaPhaseTasksData,
                        data: {
                            ...updatedCaPhaseTasksData.data,
                            data: {
                                ...updatedCaPhaseTasksData.data.data,
                                data: mapTasks(updatedCaPhaseTasksData.data.data.data)
                            }
                        }
                    };
                }
            }

            return {
                ...state,
                loader: false,
                caPhaseTasksData: updatedCaPhaseTasksData
            };
        }
        case GET_RUNNING_FRONTAPP_TASK:
            return {
                ...state
            };
        case GET_RUNNING_FRONTAPP_TASK_SUCCESS:
            return {
                ...state,
                runningFrontAppTask: action.payload,
            };
        case GET_RUNNING_FRONTAPP_TASK_FAILURE:
            return {
                ...state,
                runningFrontAppTask: null,
            };
        default:
            return state;
    }
};

export default FrontAppReducer;
